import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PropTypes } from 'prop-types';
import 'bootstrap/scss/bootstrap.scss';
import ModalsRoot from './modals/ModalsRoot';
import { updateUtm } from './actions/userActions';
import { getConfig } from './actions/configActions';
import { getParams, scrollScreenToTop } from './utils/other';

import './styles/App.scss';
import FeedbackBubbleComponent from './components/FeedbackBubbleComponent';
import GDPRBanner from './components/GDPRBanner';
import FullStoryContainer from './containers/FullStoryContainer';
import ScrollTo from './ScrollTo';
import GoogleAnalyticsInitialize from './GoogleAnalyticsInitialize';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.mountRouteChangeAction();
  }

  componentDidMount() {
    this.updateUtmIfNeeded();
    this.props.getConfig();
  }

  mountRouteChangeAction() {
    this.props.history.listen(() => {
      this.updateUtmIfNeeded();
      scrollScreenToTop();
    });
  }

  updateUtmIfNeeded() {
    const paramsString = this.props.location.search || '';
    if (paramsString.includes('utm_')) {
      this.props.updateUtm(getParams(paramsString));
    }
  }

  render() {
    return (
      <div className="app">
        <FullStoryContainer />
        <GoogleAnalyticsInitialize />
        <ModalsRoot />
        <ScrollTo />
        <FeedbackBubbleComponent />
        <div>
          {this.props.children}
        </div>
        <GDPRBanner />
      </div>
    );
  }
}

App.propTypes = {
  history: PropTypes.shape({
    listen: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired,
  updateUtm: PropTypes.func.isRequired,
  children: PropTypes.node,
  getConfig: PropTypes.func.isRequired
};

App.defaultProps = {
  children: null
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  updateUtm: params => dispatch(updateUtm(params)),
  getConfig: () => dispatch(getConfig())
});

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(App)
);



// WEBPACK FOOTER //
// ./src/App.js